import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Director from 'components/BKantarciHome/Director.jsx';
import Header from 'components/BKantarciHome/header.jsx';
import DirectorMobile from 'components/BKantarciHome/Director_mobile';
import Body from 'components/BKantarciHome/Body.jsx';
import BodyMobile from 'components/BKantarciHome/Body _mobile.jsx';

function Home() {

    const isMobile = useSelector(state => state.windowSize.isMobile);
  
    return (
      <>
      {isMobile ? ( 
        <>
          <MobileNavbar />
          <Header />
          <hr />
          <DirectorMobile />
          <hr />
          <BodyMobile />
          <hr />
          <MobileFooter />
        </>
      ) : (
        <>
          <Navbar />
          <Header />
          <hr />
          <Director />
          <hr />
          <Body />
          <hr />
          <Footer />
        </>
      )}
      </>
    );
  }
  
  export default Home;